import React, { useState } from "react";
import SelectionPanel from "../../molecules/SelectionPanel/SelectionPanel";
import ExampleField from "../../molecules/ExampleField/ExampleField";

import { APIFieldType, FieldTypeType } from "../../../services/helpers/types";
import Button from "../../atoms/Button/Button";
import AddFieldValuesForm from "../AddFieldValuesForm/AddFieldValuesForm";
import { useDispatch } from "react-redux";
import { setIsEditDrawerOpen } from "../../../redux/reducers/appReducer";
import useEditDrawerState from "../../../services/hooks/useEditFieldState";
import { useTranslation } from "react-i18next";
import {
  getBooleanField,
  getBooleanTextField,
  getButtonField,
  getButtonGroupField,
  getCascaderField,
  getMultiSelectField,
  getNumberField,
  getNumberNumberField,
  getSelectField,
  getStaticTextField,
  getTextField,
  getUrineField,
  getBMICalculatorField,
} from "../../../services/helpers/exampleFields";

interface AddFieldFormProps {
  tabID: number;
  position: number;
  onCreateField: (fieldID: number, newField: APIFieldType) => void;
}

const AddFieldForm = (props: AddFieldFormProps) => {
  const { tabID, position, onCreateField } = props;

  const dispatch = useDispatch();
  const editDrawerState = useEditDrawerState();
  const { t } = useTranslation();

  const [selectedField, setselectedField] = useState<FieldTypeType>(
    FieldTypeType.Text,
  );

  const handleCreateNewField = (fieldID: number, newField: APIFieldType) => {
    dispatch(setIsEditDrawerOpen({ isOpen: true, type: "add" }));
    onCreateField(fieldID, newField);
  };

  const handleSelectField = () => {
    dispatch(setIsEditDrawerOpen({ isOpen: true, type: "addSelected" }));
  };

  if (editDrawerState.isOpen && editDrawerState.type === "addSelected") {
    return (
      <AddFieldValuesForm
        type={selectedField}
        onBack={() =>
          dispatch(setIsEditDrawerOpen({ isOpen: true, type: "add" }))
        }
        mode="add"
        tabID={tabID}
        position={position}
        afterCreate={handleCreateNewField}
      />
    );
  }

  return (
    <div className="dui-add-field">
      <h1>{t("chooseOneOption")}</h1>
      <div className="dui-add-field-content">
        <SelectionPanel title={t("fastTextInput")}>
          <div className="dui-add-field-fields">
            <ExampleField
              field={getTextField(t)}
              title={getTextField(t).name}
              defaultValue={getTextField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Text}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getNumberField(t)}
              title={getNumberField(t).name}
              defaultValue={getNumberField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Number}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getNumberNumberField(t)}
              title={getNumberNumberField(t).name}
              defaultValue={getNumberNumberField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.NumberNumber}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getBooleanTextField(t)}
              title={getBooleanTextField(t).name}
              defaultValue={getBooleanTextField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.BooleanText}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
          </div>
        </SelectionPanel>
        <SelectionPanel title={t("selectFieldsTitle")}>
          <div className="dui-add-field-fields">
            <ExampleField
              field={getSelectField(t)}
              title={getSelectField(t).name}
              defaultValue={getSelectField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Select}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getMultiSelectField(t)}
              title={getMultiSelectField(t).name}
              defaultValue={getMultiSelectField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.MultipleChoice}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getCascaderField(t)}
              title={getCascaderField(t).name}
              defaultValue={getCascaderField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Cascader}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getButtonGroupField(t)}
              title={getButtonGroupField(t).name}
              defaultValue={getButtonGroupField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.ButtonGroup}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getBooleanField(t)}
              title={getBooleanField(t).name}
              defaultValue={getBooleanField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Boolean}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
          </div>
        </SelectionPanel>
        <SelectionPanel title={t("staticTextFieldsTitle")}>
          <div className="dui-add-field-fields">
            <ExampleField
              field={getStaticTextField(t)}
              title={getStaticTextField(t).name}
              titlePosition="top"
              defaultValue={getStaticTextField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.StaticText}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
            <ExampleField
              field={getButtonField(t)}
              title={getButtonField(t).name}
              titlePosition="top"
              defaultValue={""}
              isSelected={selectedField === FieldTypeType.Button}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
            />
          </div>
        </SelectionPanel>
        <SelectionPanel title={t("customFieldsTitle")}>
          <div className="dui-add-field-fields">
            <ExampleField
              field={getUrineField(t)}
              title={getUrineField(t).name}
              defaultValue={getUrineField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.Urine}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
              className="dui-example-field-urine"
            />
            <ExampleField
              field={getBMICalculatorField(t)}
              title={getBMICalculatorField(t).name}
              defaultValue={getBMICalculatorField(t).defaultValue}
              isSelected={selectedField === FieldTypeType.BMICalculator}
              onSelectField={(fieldType) => {
                setselectedField(fieldType);
              }}
              className="dui-example-field-urine"
            />
          </div>
        </SelectionPanel>
      </div>
      <div className="dui-add-field-actions">
        <Button onClick={handleSelectField}>{t("next")}</Button>
      </div>
    </div>
  );
};

export default AddFieldForm;
